import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

const sizes = { sm: 14, md: 20, lg: 30 } as const;

export function Spinner({
  size = 'md',
  className,
}: {
  size?: keyof typeof sizes;
  className?: string;
}) {
  return (
    <Loader2
      size={sizes[size]}
      className={cn('animate-spin text-primary', className)}
      role="status"
      aria-label="Loading"
    />
  );
}

/**
 * The in-panel loading state.
 *
 * Sits inside the content card rather than replacing the whole page, so the
 * title, breadcrumb and toolbar stay put while data arrives — the page does
 * not flash its own chrome away and back on every refetch.
 */
export function PageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex h-64 flex-col items-center justify-center gap-2.5">
      <Spinner size="lg" />
      <p className="text-[11px] text-muted-foreground">{label}</p>
    </div>
  );
}
